var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    transform: "translate(0 1)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.92183 5.01782H9.18902C9.02964 5.01782 8.87808 5.09438 8.78433 5.22563L6.32808 8.63189L5.21558 7.08813C5.12183 6.95845 4.97183 6.88032 4.81089 6.88032H4.07808C3.97652 6.88032 3.91714 6.99595 3.97652 7.07876L5.92339 9.77876C5.96938 9.84295 6.03001 9.89526 6.10026 9.93134C6.1705 9.96743 6.24833 9.98625 6.3273 9.98625C6.40627 9.98625 6.4841 9.96743 6.55434 9.93134C6.62458 9.89526 6.68521 9.84295 6.7312 9.77876L10.0218 5.21626C10.0828 5.13345 10.0234 5.01782 9.92183 5.01782Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.502686C3.13437 0.502686 0 3.63706 0 7.50269C0 11.3683 3.13437 14.5027 7 14.5027C10.8656 14.5027 14 11.3683 14 7.50269C14 3.63706 10.8656 0.502686 7 0.502686ZM7 13.3152C3.79063 13.3152 1.1875 10.7121 1.1875 7.50269C1.1875 4.29331 3.79063 1.69019 7 1.69019C10.2094 1.69019 12.8125 4.29331 12.8125 7.50269C12.8125 10.7121 10.2094 13.3152 7 13.3152Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.e1384b79d787f9f1b2fa253960465818.svg";
export { ForwardRef as ReactComponent };